import LockResetIcon from "@mui/icons-material/LockReset";
import PeopleIcon from "@mui/icons-material/People";
import {Dialog} from "@mui/material";
import {GridActionsCellItem} from "@mui/x-data-grid";
import {
  Button,
  dateValueGetter,
  GridColumnSettings,
  PageHeader,
  Spacer,
  useDialog,
} from "common";
import I18n from "i18n-js";
import UserChangePasswordForm from "./ChangePassword/UserChangePasswordForm";
import {UserListItem} from "./userApi";
import useUserList from "./useUserList";
import InviteForm from "./Invite/InviteForm";
import UserForm from "./UserForm";
import DataCard from "../../../components/DataCard/DataCard";

export default function StaffUsers() {
  const {
    grid,
    userLimit,
    userCount,
    canInviteUser,
  } = useUserList();
  const [
    userToChangePassword,
    setUserToChangePassword,
    userToChangePasswordDialog,
  ] = useDialog<UserListItem>();
  const [inviteDialogOpen, setInviteDialogOpen, inviteDialog] = useDialog();
  let columnSettings: GridColumnSettings = {
    date: {valueFormatter: dateValueGetter},
  };

  return (
    <>
      <PageHeader avatar={<PeopleIcon/>} title={I18n.t("Users.title")}/>
      <Button
        onClick={() => {
          setInviteDialogOpen(true);
        }}
        startIcon={<PeopleIcon />}
        // disabled={true}
        // disabled={!canInviteUser}
      >
        {I18n.t("InviteForm.invite")}
      </Button>
      <Spacer h={2}/>
      <DataCard
        {...grid}
        renderModalForm={props => <UserForm {...props} />}
        cardSettings={columnSettings}
        headerItems={["search", "refresh"]}
        canDelete
        canEdit
        canEditCard={(params: any) => params.row?.can_modify}
        canDeleteCard={(params: any) => params.row?.can_modify}
        cardActions={(params: any) => [
          <GridActionsCellItem
            icon={<LockResetIcon/>}
            disabled={!params.row?.can_modify}
            label={I18n.t("PasswordChange.title")}
            title={I18n.t("PasswordChange.title")}
            onClick={() => setUserToChangePassword(params.row)}
          />,
        ]}
      />
      <Dialog {...inviteDialog} maxWidth="xs" fullWidth>
        <InviteForm onModalClose={inviteDialog.onClose}/>
      </Dialog>
      <Dialog {...userToChangePasswordDialog} maxWidth="xs" fullWidth>
        <UserChangePasswordForm
          onClose={userToChangePasswordDialog.onClose}
          user={userToChangePassword}
          afterSave={
            (() =>
              userToChangePasswordDialog.onClose &&
              userToChangePasswordDialog.onClose({}, "backdropClick")) as any
          }
        />
      </Dialog>
    </>
  );
}
